/* eslint-disable import/extensions */
import { IdleQueue } from 'idlize/IdleQueue.mjs'

import tracking from '@titanio/tracking'

const loader = () => {
  const queue = new IdleQueue()

  queue.pushTask(() => {
    tracking.mount()
    tracking.send()
  })
}

export default { loader }
